var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 16.25H14.9039C14.875 17.0238 14.3293 17.5 13.625 17.5H11.25C10.5199 17.5 9.96016 16.8176 9.96992 16.25H0.625C0.28125 16.25 0 16.5312 0 16.875V17.5C0 18.875 1.125 20 2.5 20H22.5C23.875 20 25 18.875 25 17.5V16.875C25 16.5312 24.7188 16.25 24.375 16.25ZM22.5 1.875C22.5 0.84375 21.6562 0 20.625 0H4.375C3.34375 0 2.5 0.84375 2.5 1.875V15H22.5V1.875ZM20 12.5H5V2.5H20V12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/Vector-4.a6063b891473a2c7d14cb308a4972fac.svg";
export { ForwardRef as ReactComponent };